export default {
  // Page title and subtitle
  'page.mainTitle': 'Generator Timestamp Discord',
  'page.mainTitleSEO': 'Generator Timestamp Discord - Buat Kode Format <t:> Dinamis',
  'page.subtitle': 'Buat timestamp Discord dengan konversi zona waktu otomatis untuk semua orang',

  // Generator tool section
  'page.generatorTitle': 'Generator Timestamp Discord Interaktif',
  'page.selectDateTime': 'Pilih Tanggal & Waktu:',
  'page.chooseFormat': 'Pilih Format Tampilan:',
  'page.generatedCode': 'Kode Discord yang Dihasilkan:',
  'page.preview': 'Pratinjau di Discord:',
  'page.copyCode': 'Salin Kode',

  // Format options
  'page.format.t': 'Waktu Singkat',
  'page.format.t.example': '4:30 PM',
  'page.format.t.desc': 'Menampilkan waktu saja, format singkat',

  'page.format.T': 'Waktu Panjang',
  'page.format.T.example': '4:30:00 PM',
  'page.format.T.desc': 'Menampilkan waktu saja, dengan detik',

  'page.format.d': 'Tanggal Singkat',
  'page.format.d.example': '12/31/2024',
  'page.format.d.desc': 'Menampilkan tanggal saja, format singkat',

  'page.format.D': 'Tanggal Panjang',
  'page.format.D.example': 'December 31, 2024',
  'page.format.D.desc': 'Menampilkan tanggal lengkap',

  'page.format.f': 'Tanggal/Waktu Singkat',
  'page.format.f.example': 'December 31, 2024 4:30 PM',
  'page.format.f.desc': 'Format yang paling umum digunakan',

  'page.format.F': 'Tanggal/Waktu Panjang',
  'page.format.F.example': 'Tuesday, December 31, 2024 4:30 PM',
  'page.format.F.desc': 'Tanggal dan waktu lengkap dengan hari dalam seminggu',

  'page.format.R': 'Waktu Relatif',
  'page.format.R.example': '2 jam yang lalu / dalam 3 hari',
  'page.format.R.desc': 'Hitung mundur dinamis atau waktu yang berlalu',

  // Format reference table
  'page.formatReference': 'Referensi Format Timestamp Discord',
  'page.formatCode': 'Kode Format',
  'page.style': 'Gaya',
  'page.exampleOutput': 'Contoh Keluaran',
  'page.useCase': 'Kasus Penggunaan',

  'page.useCase.t': 'Waktu mulai acara',
  'page.useCase.T': 'Waktu yang tepat',
  'page.useCase.d': 'Tampilan tanggal kompak',
  'page.useCase.D': 'Tampilan tanggal lengkap',
  'page.useCase.f': 'Tujuan umum',
  'page.useCase.F': 'Pengumuman resmi',
  'page.useCase.R': 'Hitung mundur, waktu sejak acara',

  // How to use section
  'page.howToUse': 'Cara Menggunakan Timestamp Discord',
  'page.step1': 'Buat kode timestamp Anda',
  'page.step1Desc': 'Gunakan alat di atas untuk memilih tanggal/waktu dan format',

  'page.step2': 'Salin kode yang dihasilkan',
  'page.step2Desc': 'Contoh: <t:1735689000:F>',

  'page.step3': 'Tempel ke pesan Discord mana pun',
  'page.step3Desc': 'Berfungsi di saluran teks, DM, thread, dan postingan forum',

  'page.step4': 'Semua orang melihatnya di zona waktu mereka!',
  'page.step4Desc': 'Discord secara otomatis mengonversi ke waktu lokal setiap pengguna',

  // FAQ section
  'page.faq': 'FAQ Timestamp Discord',

  'page.faq.q1': 'Apa itu timestamp Discord?',
  'page.faq.a1': 'Timestamp Discord menggunakan waktu epoch Unix dengan kode format khusus (<t:timestamp:format>) untuk menampilkan waktu dinamis yang secara otomatis menyesuaikan dengan zona waktu lokal setiap pengguna.',

  'page.faq.q2': 'Mengapa menggunakan timestamp Discord daripada mengetik waktu?',
  'page.faq.a2': 'Timestamp Discord secara otomatis mengonversi ke zona waktu lokal setiap pengguna, sehingga semua orang melihat waktu yang benar untuk lokasi mereka. Ini menghilangkan kebingungan saat mengoordinasikan acara di berbagai zona waktu.',

  'page.faq.q3': 'Format mana yang harus saya gunakan?',
  'page.faq.a3': 'Gunakan <t:timestamp:R> untuk hitung mundur dan acara, <t:timestamp:F> untuk pengumuman resmi, dan <t:timestamp:f> untuk tujuan umum.',

  'page.faq.q4': 'Apakah timestamp Discord berfungsi di semua saluran?',
  'page.faq.a4': 'Ya! Timestamp Discord berfungsi di saluran teks, DM, thread, postingan forum, dan bahkan di topik saluran.',

  'page.faq.q5': 'Bisakah saya menggunakan timestamp Discord di embed?',
  'page.faq.a5': 'Ya, timestamp Discord berfungsi di deskripsi embed dan nilai field saat menggunakan bot Discord.',

  'page.faq.q6': 'Apa yang terjadi jika saya menggunakan timestamp yang tidak valid?',
  'page.faq.a6': 'Discord akan menampilkan kode mentah tanpa mengonversinya. Pastikan untuk menggunakan timestamp Unix yang valid.',

  // Related tools section
  'page.relatedTools': 'Alat Timestamp Terkait',
  'page.needUnixTimestamp': 'Butuh Timestamp Unix?',
  'page.needUnixTimestampDesc': 'Gunakan Konverter Timestamp Unix kami untuk mengonversi tanggal apa pun ke waktu epoch.',
  'page.checkYouTubeTool': 'Atau lihat Pembuat Timestamp YouTube',

  // Common use cases
  'page.commonUseCases': 'Kasus Penggunaan Umum',
  'page.useCase1.title': 'Penjadwalan Acara',
  'page.useCase1.desc': 'Umumkan malam permainan, pesta menonton film, atau acara komunitas',

  'page.useCase2.title': 'Timer Raid',
  'page.useCase2.desc': 'Koordinasikan sesi permainan di berbagai zona waktu',

  'page.useCase3.title': 'Hitung Mundur Rilis',
  'page.useCase3.desc': 'Buat kegembiraan untuk peluncuran game, rilis album, atau pembaruan',

  'page.useCase4.title': 'Pengingat Rapat',
  'page.useCase4.desc': 'Jadwalkan rapat tim di server komunitas',

  'page.useCase5.title': 'Batas Waktu Kontes',
  'page.useCase5.desc': 'Tetapkan batas waktu yang jelas untuk giveaway dan kompetisi',

  'page.useCase6.title': 'Acara Server',
  'page.useCase6.desc': 'Lacak ulang tahun, pencapaian, dan acara khusus',
};
